"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MyContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var MyContext = _react["default"].createContext();

exports.MyContext = MyContext;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Menu, _React$Component);

  function Menu() {
    (0, _classCallCheck2["default"])(this, Menu);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).apply(this, arguments));
  }

  (0, _createClass2["default"])(Menu, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
          selectProps = _this$props.selectProps,
          innerProps = _this$props.innerProps,
          children = _this$props.children;
      return _react["default"].createElement(_reactSelect.components.Menu, this.props, _react["default"].createElement(_Paper["default"], (0, _extends2["default"])({
        square: true,
        className: "".concat(selectProps.classes.paper)
      }, innerProps), children));
    }
  }]);
  return Menu;
}(_react["default"].Component);

var _default = Menu;
exports["default"] = _default;